import { Box, Icon, Heading } from "@ogt/ui";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useUnregisterFlow } from "../hooks/useUnregisterFlow";

export default function UnregisterTravelSuccess() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const { unregisterData } = useUnregisterFlow();
  const navigate = useNavigate();

  useEffect(() => {
    if (!unregisterData) {
      navigate("/avboka-resa");
      return;
    }

    const { EditId, ReferenceId } = unregisterData;

    if (!EditId || !ReferenceId) {
      navigate("/avboka-resa-fel");
      return;
    }
  }, [unregisterData, navigate]);

  return (
    <div>
      <Box>
        <Heading headingRef={h2Ref}>Er gruppresa är avanmäld!</Heading>
        <p>
          Gruppresa med referensnummer {unregisterData?.ReferenceId} är avanmäld
          och borttagen.
        </p>
        <Heading headingRef={h2Ref}>Behöver ni anmäla en ny gruppresa?</Heading>
        <p>
          Ibland blir det inte som man tänkt sig. Vi hjälper er att anmäla en ny
          gruppresa.
        </p>
        <button
          type="button"
          onClick={() => navigate("/")}
          className="stripped md:hover:underline md:hover:decoration-1 focus-visible:underline focus-visible:decoration-1 md:active:underline md:active:decoration-2 focus-visible:outline-2 focus-visible:outline-focus focus-visible:outline-offset-4 text-red-darker text-lg inline-flex items-center"
        >
          Anmäl gruppresa
          <Icon name="chevron-right" />
        </button>
      </Box>
    </div>
  );
}
